/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import {
  GETCLUBWALLETLIST,
  GETCLUBWALLETTYPE,
  GETSELECTWALLET,
} from './constants'

export const getClubWalletList = (payload) => {
  return {
    type: GETCLUBWALLETLIST,
    payload,
  }
}
export const getSelectWallet = (payload) => {
  return {
    type: GETSELECTWALLET,
    payload,
  }
}

export const getClubWalletType = (payload) => {
  return {
    type: GETCLUBWALLETTYPE,
    payload,
  }
}

//钱包
export function fetchClubWalletList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/getWalletInfo`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubWalletList(data))
      return data
    })
  }
}

//删除
export function fetchDelWallet(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/DelClubWallet/id/${id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubWalletList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改
export function fetchUpdateClubWallet(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/UpdateClubWallet`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubWalletList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//增加
export function fetchAddClubWallet(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/AddClubWallet`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubWalletList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}
//桌台类型
export function fetchClubWalletType() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/AddClubWallet`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubWalletType(data.list))
    })
  }
}

//已选择
export function fetchUpdateWalletType(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/UpdateClubWallet`
    return postData(endpoint).then((data) => {
      dispatch(getSelectWallet(data.list))
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubWallet/action.js